import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { LWApiPublicMarketCartDetailsResultRawI } from '@liquidweb-dev/club-sauce/public/market/cart/index.raw';
import type { LWApiPublicMarketCartItemAddParamsRawI } from '@liquidweb-dev/club-sauce/public/market/cart/item.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import { MARKET_CART_DETAILS_QUERY_KEY } from '../useDetails';

const useCartItemAdd = () => {
	const snackbarError = useSnackbarError();
	const queryClient = useQueryClient();

	return useMutation<
		LWApiPublicMarketCartDetailsResultRawI,
		ApiErrorI,
		LWApiPublicMarketCartItemAddParamsRawI
	>({
		mutationFn: (params) => api.market.cart.item.apiRaw.add(params),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [MARKET_CART_DETAILS_QUERY_KEY],
			});
		},
		onError: snackbarError,
	});
};

export default useCartItemAdd;
